import React from 'react';
import Popup from 'reactjs-popup';
import WaitingGatewayRow from '../../containers/DevicesDetail/WaitingGatewayRow';
import useDeviceSerials from '../../hooks/useDeviceSerials';

// Every held gateway of the customer, scrollable. Serials load only while open.
const WaitingGatewaysModal = ({ open, setOpen, devices, facilities }) => {
    const serials = useDeviceSerials(open ? devices.map(d => d.id) : []);
    const close = () => setOpen(false);

    return (
        <Popup open={open} onClose={close} modal className="modal">
            <div>
                <button className="modal__close" onClick={close} aria-label="Close">
                    &#10005;
                </button>
                <h5 className="modal__header">Awaiting connection ({devices.length})</h5>
                <ul className="gateway-section__waiting-list gateway-section__waiting-list--scroll" data-testid="waiting-gateways-all">
                    {devices.map(device => (
                        <WaitingGatewayRow key={device.id} device={device} serial={serials[device.id]} facilities={facilities} />
                    ))}
                </ul>
            </div>
        </Popup>
    );
};

export default WaitingGatewaysModal;
